/**
 * Role-based access control utilities
 * Cookies are for UI control only - security is enforced by backend CheckShopRole middleware
 */

export const ROLES = {
  OWNER: 'owner',
  SHIPPING_STAFF: 'shipping_staff',
  CUSTOMER_SUPPORT: 'customer_support',
};

// Page access permissions per role
const ROLE_PERMISSIONS = {
  [ROLES.OWNER]: [
    'stock', 'oripa', 'new-oripa', 'single', 'ship', 'sales', 'ranking',
    'shop-payment', 'settle', 'settle-payment', 'user', 'shop', 'shop-edit',
    'wms-settings', 'rate', 'staff', 'shop-payment-coupon', 'operator-announcement',
    'draw-transactions', 'ship-payments', 'refund-queue', 'point-grant-rules',
  ],
  [ROLES.SHIPPING_STAFF]: [
    'ship',
  ],
  [ROLES.CUSTOMER_SUPPORT]: [
    'user', 'ship', 'settle', 'settle-payment',
    'draw-transactions', 'ship-payments', 'refund-queue',
  ],
};

export function getUserRole() {
  const cookies = document.cookie.replace(/ /g, '').split(';');
  let role = null;
  cookies.forEach(cookie => {
    const [key, value] = cookie.split('=');
    if (key === 'user_role') {
      role = value;
    }
  });
  return role;
}

export function getUserType() {
  const cookies = document.cookie.replace(/ /g, '').split(';');
  let userType = null;
  cookies.forEach(cookie => {
    const [key, value] = cookie.split('=');
    if (key === 'user_type') {
      userType = value;
    }
  });
  return userType;
}

export function setRoleCookies(role, userType) {
  if (role) {
    document.cookie = `user_role=${role};max-age=946080000;path=/`;
  }
  if (userType) {
    document.cookie = `user_type=${userType};max-age=946080000;path=/`;
  }
}

export function clearRoleCookies() {
  document.cookie = 'user_role=; expires=Thu, 01 Jan 1970 00:00:00 GMT;max-age=0;path=/';
  document.cookie = 'user_type=; expires=Thu, 01 Jan 1970 00:00:00 GMT;max-age=0;path=/';
}

export function hasPermission(role, page) {
  if (!role) return true; // role未取得時は全て表示（後方互換性）
  const permissions = ROLE_PERMISSIONS[role];
  if (!permissions) return true; // 未知のroleは全て表示
  return permissions.includes(page);
}

export function getDefaultPage(role) {
  if (role === ROLES.SHIPPING_STAFF) return 'ship';
  if (role === ROLES.CUSTOMER_SUPPORT) return 'user';
  return 'stock';
}
